// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"e775601c","293":"b46172c9","316":"a51d5d79","484":"1090fcbb","658":"612ccef5","706":"02621d7b","776":"cefeae2e","979":"d5910efe","980":"30c89e64","983":"f108bb48"}[chunkId] + ".chunk.js";
};